export default __webpack_public_path__ + "static/media/Zing_image@2x.15f2f559.png";